<template>
  <div>
    <a-modal
      title="区域绘制" 
      :visible="modal"
      @cancel="cancel"
      width="1000px"
    >
      <div style="margin-bottom: 16px;">
        <a-input v-model="localFloorName" placeholder="楼层名称" style="width: 200px" />
        <a-input v-model="localAreaName" placeholder="区域名称" style="width: 200px;margin-left: 16px" />
        <a-input v-model="localPersonLimit" placeholder="人数限制" style="width: 200px;margin-left: 16px" type="number" min="0" />
        <a-select v-model="localAreaType" placeholder="区域类型" style="width: 200px;margin-left: 16px">
          <a-select-option :value=1>禁入</a-select-option>
          <a-select-option :value=2>禁出</a-select-option>
          <a-select-option :value=3>无限制</a-select-option>
        </a-select>
      </div>  
      <div style="height: 500px">
        <div class="comp-map" id="compMap"></div>
      </div>
      <div slot="footer">
        <a-button type="dashed" @click="cancel">取消</a-button>
        <a-button type="primary" @click="ok">提交</a-button>
        <a-button type="danger" @click="delArea" v-if="optType !== 1">删除</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script> 
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.pm";
import "leaflet.pm/dist/leaflet.pm.css";

export default {
  props: {
    data: {
      type: Object,
    },
    mapUrl: {
      type: String,
      default: ''
    },
    mapBounds: {
      type: Array,
      default: () => []
    },
    drawMarker: {
      type: Boolean,
      default: false
    },
    areaBounds: {
      type: Array,
      default: () => []
    },
    floorName: {
      type: String,
      default: ''
    },
    areaName: {
      type: String,
      default: ''
    },
    personLimit: {
      type: Number,
      default: null
    },
    areaType: {
      type: Number,
      default: null
    },
    optType: {
      type: Number,
      default: null
    }, 
     

  },
  data() {
    return {
      modal:true,
      markerCoords: [], //所打点的坐标集合
      map: null,
      latlngs: [],
      layer: null,
      domMarker: null,
      domCoords: null,
      layers: [],
      editId: null,
      addMarker: null,
      addCoords: null,
      floorId: null,
      localFloorName: this.floorName,
      localAreaName: this.areaName,
      localPersonLimit: this.personLimit,
      localAreaType: this.areaType,
    };
  },
  mounted () {
    this.modal = true
    this.$nextTick(() => {
      this.initLeftMap()
    })
  },
  methods: {
    //地图初始化
    initLeftMap(drawMarker, drawArea = true, removalMode = true) {
      if(this.map){
        this.map.remove()
      }
      let map = L.map("compMap", {
        minZoom: 1,
        maxZoom: 8,
        zoom: 6,
        crs: L.CRS.Simple,
        doubleClickZoom: false, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
        zoomSnap: 0.1, //缩放倍数
        zoomControl: false,
      });
      this.map = map;
      // let s = this.data.bounds.split(",");
      // let bounds = [
      //   [s[0].split("_")[0],s[0].split("_")[1]],
      //   [s[1].split("_")[0],s[1].split("_")[1]]
      // ]
      // console.log(bounds)
      L.imageOverlay(this.mapUrl,this.mapBounds).addTo(this.map);
      map.fitBounds(this.mapBounds)

      //添加比例尺
      L.control.scale({ position: "bottomright", imperial: false }).addTo(this.map);

      //点击事件
      this.map.on("click", (e) => {
        console.log(e.latlng);
      });

      this.drawArea();

      map.pm.setLang("zh");

      //添加操作控件
      map.pm.addControls({
        position: "topleft",
        drawPolygon: !this.drawMarker, // 绘制多边形
        drawMarker: drawMarker || false, //绘制标记点
        drawCircleMarker: this.drawMarker, //绘制圆形标记
        drawPolyline: false, //绘制线条
        drawRectangle: false, //绘制矩形
        drawCircle: false, //绘制圆圈
        editMode: false, //编辑多边形
        dragMode: false, //拖动多边形
        cutPolygon: false, // 添加一个按钮以删除多边形里面的部分内容
        removalMode: removalMode, // 清除多边形
      });

      this.map.on("pm:drawstart", (e) => {
        console.log("开始绘制", e);
        if (e.shape == "Marker") {
          this.addCoords = [];
          if (this.domMarker) {
            this.domMarker.remove();
          }
        } else {
          if (this.layer) {
            this.layer.remove();
          }
          console.log(this.layers);
          this.layers.map((item) => {
            if (item.aId == this.editId) {
              console.log(item, 666);
              item.remove();
            }
          });
          this.latlngs = [];
        }
      });

      //图形创建完成后
      this.map.on("pm:create", (e) => {
        console.log("图形完成", e);
        if (e.layer._latlngs) {
          this.latlngs = e.layer._latlngs[0];
          if (this.latlngs.length < 4) {
            e.layer.remove();
            this.latlngs = [];
            this.$message.warning("所选点不能小于4个!");
          }
          this.layer = e.layer;
          this.layer.aId = this.editId;
        } else {
          if (this.addCoords) {
            if (this.addMarker) {
              this.addMarker.remove();
            }
            this.addCoords = null;
          }
          this.addMarker = e.layer;
          this.addCoords = e.layer._latlng;
        }
      });
      //清除图层
      this.map.on("pm:remove", (e) => {
        console.log(e);
        if (e.layer.aId == this.editId) {
          this.latlngs = [];
        }
      });
    },

    cancel(){
      this.$emit("polygon-msg", null, null, null, null)  
    },

    ok(){
      if(!this.localAreaName){
        this.$message.error('请输入区域名称',);
        return
      }
      if(!this.localPersonLimit){
        this.$message.error('请输入人数限制',); 
        return
      }
      if(!this.localAreaType){
        this.$message.error('请选择区域类型',);
        return
      }
      if(this.drawMarker && this.addCoords){
        // 绘制标记点时传递标记点坐标
        console.log("draw marker", this.addCoords)
        this.$emit("polygon-msg", this.addCoords)
      } else if(this.latlngs.length < 4 && this.areaBounds.length < 4){
        this.$message.error('所选点不能小于4个!!');
        return
      } else {
        // 绘制多边形时传递多边形坐标
        console.log("draw polygon", this.latlngs, this.localAreaName, this.localPersonLimit, this.localAreaType, this.localFloorName)
        this.$emit("polygon-msg", this.latlngs, this.localAreaName, this.localPersonLimit, this.localAreaType, this.localFloorName)
      }
      // if(this.latlngs.length < 4){
      //   this.$Notice.error({
      //     title: '所选点不能小于4个',
      //   });
      //   return
      // }
      // console.log("draw",this.latlngs)
      // this.$emit("polygon-msg", this.latlngs)
    },
    //删除区域
    delArea(){
       this.$confirm({
        title: '确认删除吗？',
         content: '确定要删除该区域吗？',
          okText: '确认',
          okType: 'danger',
             onOk: () => {
               this.$emit("polygon-del")  
             }
      })
    },  
    //初始绘制所有围栏
    drawArea() {
      if(this.areaBounds.length > 0){
        L.polygon(this.areaBounds).addTo(this.map);
      }
    },
  },
};
</script>

<style scoped>
  .comp-map{
    transition: initial;
    height: 100%;
    width: 100%;
  }
</style>
